"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _UINavListItem = _interopRequireDefault(require("./UINavListItem"));

var _default = _react.default.createClass({
  displayName: "UINestedNavItem",
  propTypes: (0, _extends2.default)({}, _UINavListItem.default.propTypes),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UINavListItem.default.defaultProps);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children"]);
    return _react.default.createElement(_UINavListItem.default, (0, _extends2.default)({
      iconRight: children != null ? 'down' : null
    }, rest), children);
  }
});

exports.default = _default;
module.exports = exports.default;